import * as Components from "../PaymentCustomerPage/index.styles";
// import { TableDatabase } from "../../components";
import HeaderComponent from "../../components/common/HeaderSectionComponent";
import CalendarRangePicker from "../../components/paymentCustomerComponents/ModalDateRange";
// import { Spinner } from "react-rainbow-components";
import useHistoryRecordPage from "./useHistoryRecordPage";
import { columns } from "./conversDataToTableRows";
import useWindowDimensions from "../../functions/windows";
import InfomationDatabase from "../../components/common/InfomationDatabase";
import convertDataToInfo from "./convertDataToInfo";
import { CustomTable } from "./index.styles";
// import { IRecord } from "../../interfaces/record";
import { ColumnsType } from "antd/lib/table";

export default function HistoryRecordPage() {
  const {
    setSearchKey,
    dataForShow,
    isLoading,
    setInitialDate,
    setFinaleDate,
  } = useHistoryRecordPage();

  // const header = [
  //   "วันที่บันทึก",
  //   "ชื่อลูกค้า",
  //   "ประเภทการรักษา",
  //   "อาการโดยสรุป",
  //   "สัตว์แพทย์ที่ให้คำปรึกษา (Id)",
  // ];

  const { width } = useWindowDimensions();

  return (
    <Components.Container>
      <Components.HeaderSection>
        <HeaderComponent title="History Record" subheader="ประวัติการรักษา" />
        <Components.ContainerSeachData>
          <Components.ContainerSearce>
            <p>ค้นหา</p>
            <Components.SearchInput
              placeholder="ชื่อ / ชื่อไลน์ / แพคเกจ / tags"
              onChange={(event) => setSearchKey(event.target.value)}
            />
          </Components.ContainerSearce>
          <CalendarRangePicker
            initalDate={setInitialDate}
            finaleDate={setFinaleDate}
          />
        </Components.ContainerSeachData>
      </Components.HeaderSection>
      {width > 767 ? (
        <Components.SectionBodyContainer>
          {/* {!isLoading ? (
            <TableDatabase
              header={header}
              tableRows={convertDataToRows(dataForShow)}
            />
          ) : (
            <Spinner size="large" />
          )} */}

          <CustomTable
            columns={columns as ColumnsType<any>}
            rowKey={(record: any) => record.bookingId}
            dataSource={dataForShow}
            bordered
            loading={isLoading}
            pagination={{
              pageSize: 5,
            }}
          />
        </Components.SectionBodyContainer>
      ) : (
        <InfomationDatabase database={convertDataToInfo(dataForShow)} />
      )}
    </Components.Container>
  );
}
